import { CadClickServiceMode } from "../CadClickViewer3D/CadClickViewer3DProps";
export const CAD_CLICK_CAD_BOX_DEFAULT_PROPS = {
    serviceMode: CadClickServiceMode.WebApi,
    app: {
        id: "",
        useLocalStorage: false, // spams the localstorage with persisted settings
    },
    services: {
        webApi: {
            url: "",
            apiKey: "",
        },
    },
    export: {
        download2d: {
            zipAllFiles: false,
            zipIfMultipleFiles: true,
        },
        download3d: {
            zipAllFiles: false,
            zipIfMultipleFiles: true,
        },
        pdf3d: {
            zipAllFiles: false,
            zipIfMultipleFiles: true,
        },
        dimensionalDrawing: {
            zipAllFiles: false,
            zipIfMultipleFiles: true,
        },
        rendererOnline: {
            renderManager: "",
            templatesUrl: "",
        },
    },
    uiControlsSettings: {},
    cadBoxWebComponentProps: {
        "viewer-2d": true,
        "viewer-3d": true,
        "download-2d": true,
        "download-3d": true,
        "dimensional-drawing": false,
        renderer: false,
        "direct-insert": false,
        bim: false, // does nothing currently?
        pdf3d: false,
    },
    viewLevel: 1,
};
//# sourceMappingURL=CadClickCadBoxProps.js.map